/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type ProjectIndicatorJS_project$ref = any;
export type BUDGET_TYPE = "FIXED_PRICE" | "FIXED_PRICE_V2" | "NON_BILLABLE" | "RETAINER" | "TIME_AND_MATERIALS" | "%future added value";
import type { FragmentReference } from "relay-runtime";
declare export opaque type ProjectHeader_project$ref: FragmentReference;
declare export opaque type ProjectHeader_project$fragmentType: ProjectHeader_project$ref;
export type ProjectHeader_project = {|
  +id: string,
  +companyProjectId: ?number,
  +name: ?string,
  +projectColor: ?string,
  +isInProjectGroup: ?boolean,
  +projectGroupCompanyId: ?number,
  +projectGroupName: ?string,
  +projectGroupColor: ?string,
  +useBaseline: ?boolean,
  +budgetType: ?BUDGET_TYPE,
  +sprintTimeBox: ?boolean,
  +$fragmentRefs: ProjectIndicatorJS_project$ref,
  +$refType: ProjectHeader_project$ref,
|};
export type ProjectHeader_project$data = ProjectHeader_project;
export type ProjectHeader_project$key = {
  +$data?: ProjectHeader_project$data,
  +$fragmentRefs: ProjectHeader_project$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProjectHeader_project",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "companyProjectId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "projectColor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isInProjectGroup",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "projectGroupCompanyId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "projectGroupName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "projectGroupColor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "useBaseline",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "budgetType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sprintTimeBox",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProjectIndicatorJS_project"
    }
  ],
  "type": "ProjectType"
};
// prettier-ignore
(node/*: any*/).hash = '0bc3cec989bcca1ecb0650a9f2eedc1a';

module.exports = node;
